import { ReactNode, useState } from 'react';
import {
  Dialog,
  DialogContentHeadless,
  DialogTrigger
} from 'v5/design-system/Dialog';
import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { WithServices } from 'v5/platform/ts/services';
import { WithResourceService } from 'v5/services/io/ResourceService/ResourceService';
import { WithAppScopeService } from 'v5/services/internal/AppScopeService/AppScopeService';
import { WithSystemSettingsService } from 'v5/services/internal/SystemSettingsService/SystemSettingsService';
import { BookingCostDialogContent } from './booking/BookingCostDialogContent';
import { ExpenseCostDialogContent } from './expense/ExpenseCostDialogContent';
import { EntitySpec } from './types';

export interface BookingCostDialogProps
  extends WithServices<
    [WithAppScopeService, WithSystemSettingsService, WithResourceService]
  > {
  entitySpec: EntitySpec;
  className?: string;
  children: ReactNode;
}

export const BookingCostDialog = ({
  entitySpec,
  className,
  children,
  services
}: BookingCostDialogProps) => {
  const [open, setOpen] = useState(false);

  const renderDialogContent = () => {
    switch (entitySpec.type) {
      case 'expense':
        return (
          <ExpenseCostDialogContent
            entitySpec={entitySpec}
            open={open}
            onOpenChange={setOpen}
          />
        );
      case 'booking':
        return (
          <BookingCostDialogContent
            entitySpec={entitySpec}
            open={open}
            onOpenChange={setOpen}
            services={services}
          />
        );
    }
  };
  return (
    <UnsavedChangesProtection open={open} onOpenChange={setOpen}>
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogTrigger asChild className={className}>
            {children}
          </DialogTrigger>
          <DialogContentHeadless>{renderDialogContent()}</DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
};
